import { HumanReadableProposalStatus } from "work/proposals/__constants/proposal-lifecycle";

/**
 * The stage a proposal is at, spelled for a reader.
 *
 * The status arrives from the API as a backend `ProposalStatusType` name.
 * `HumanReadableProposalStatus` already spells out the ones the proposal pages show; a stage it
 * does not list — the backend has `RevisionRejected`, which the frontend enum has never carried —
 * is spaced out of its PascalCase rather than reported as "Unknown", so a stage this app has not
 * been taught still reads as itself.
 *
 * This is the plain stage, not `Proposal.displayStatus`. That one rephrases the stage for whoever
 * is being waited on ("Awaiting Your Approval"), which it can only do from the teams and reviewers
 * of a fully loaded proposal — the lists this label serves hold nothing of the sort.
 */
export function getProposalStatusLabel(status: string | undefined | null): string | undefined {
  if (!status) return undefined;

  const spelled = HumanReadableProposalStatus[status as keyof typeof HumanReadableProposalStatus];
  if (spelled) return spelled.trim();

  return status.replace(/([a-z0-9])([A-Z])/g, "$1 $2").trim();
}
